import { evaluate as engineEvaluate, type ExprNode } from '@learnforge/demo-math/expr';

function safeEval(node: ExprNode, scope: Record<string, number>): number {
  try {
    const result = engineEvaluate(node, scope);
    if (typeof result !== 'number') return Number.NaN;
    if (Number.isNaN(result)) return Number.NaN;
    return result;
  } catch {
    return Number.NaN;
  }
}

export function evaluate(node: ExprNode, x: number): number {
  return safeEval(node, { x });
}

export function sampleCurve(
  node: ExprNode,
  xMin: number,
  xMax: number,
  samples: number,
): Float64Array {
  const buf = new Float64Array(samples);
  if (samples <= 0) return buf;
  if (samples === 1) {
    buf[0] = safeEval(node, { x: xMin });
    return buf;
  }
  const step = (xMax - xMin) / (samples - 1);
  for (let i = 0; i < samples; i++) {
    const x = xMin + i * step;
    buf[i] = safeEval(node, { x });
  }
  return buf;
}
